import HelpDialogLayout, { BodyTypographies, ContentStack, HelpDialogLayoutProps } from "./HelpDialogLayout";


export interface EfficiencyDialogProps
  extends HelpDialogLayoutProps {
}
export default function EfficiencyDialog(props: EfficiencyDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <BodyTypographies
          contents={[
            "睡眠効率とは、実際に眠っていた時間を寝床にいた時間で割った割合、つまり実際にはどれくらい寝れているのか、を指します。この数値は生活習慣以外にも、個人差はありますが加齢や就寝環境、ストレスによって低下することがあります。",
          ]}
        />
        <BodyTypographies
          contents={[
            "加齢に伴い、睡眠を維持する機能が弱まるため、入眠に必要な時間や中途覚醒の時間が増えやすくなります。また、定年退職後などで生活に余裕が生まれると、寝床で過ごす時間が長くなることがあり、結果として睡眠効率が低下することがあります。ただし、年齢とともに中途覚醒が増えるのは自然な現象であり、過度に心配する必要はありません。",
          ]}
        />
        <BodyTypographies
          contents={[
            "睡眠効率は就寝環境にも大きな影響を受けます。枕やマットレスなどの寝具、ペットを含むベッドパートナー、布団内の温度、周囲の騒音などが挙げられます。これらに心当たりがある場合は、環境を見直すことで睡眠効率が改善する可能性があります。",
          ]}
        />
        <BodyTypographies
          contents={[
            "ストレスは、一般的に「不安や悩み」といったネガティブなものが想起されますが、 興奮や期待といったポジティブなストレスも睡眠に影響を与えます。",
            "ストレスを受けると交感神経が優位になり、本来であれば睡眠時に働く副交感神経が抑制されることで、睡眠が妨げられます。",
          ]}
        />
        <BodyTypographies
          contents={[
            "例えば、遠足の前日に眠れないような一時的なストレスは、その要因が解消されれば自然に改善するため、あまり気にする必要はありません。",
            "しかし、仕事や人間関係などのストレスが続く場合は、睡眠を妨げてしまうため、就寝前にストレスを軽減することが重要です。",
            "例えば、ナイトルーチンとして、入浴、ストレッチやヨガ、音楽やアロマなど自分がリラックスできるものを取り入れてみましょう。",
            "また、考え事や不安を紙に書き出すことも有効です。「書く」行為はシンプルながら、感情の浄化作用が強く、また感情を客観視したり新しい視点でとらえる機会ともなり、不安が改善し、ストレスが大幅に軽減することが心理学や社会学にて報告されています。",
            "日中の適度な運動もストレス耐性を高める効果的な手段です。覚醒を減らす効果もあるため、活用してみてください。",
          ]}
        />
      </ContentStack>
    </HelpDialogLayout>
  );
}
